import axios from 'axios';

import config from '../config/config';

const isActiveSession = async (sessionId: string): Promise<boolean> => {
  const apiBaseUrl = config.expertApi.enabled ? `${config.expertApi.url}` : `${config.api.url}`;

  try {
    const response = await axios.get<{ data: boolean }>(`${apiBaseUrl}/api/v2/sessions/is-active`, {
      params: { sessionId }
    });
    return response.data.data;
  } catch (e) {
    console.error(e);
    return false;
  }
};
export default isActiveSession;
